import { createContext, useContext } from 'react';

const WorkoutMetaContext = createContext(null);

export function useWorkoutMeta() {
  const ctx = useContext(WorkoutMetaContext);
  if (!ctx) throw new Error('useWorkoutMeta must be used within WorkoutSessionProvider');
  return ctx;
}

export default WorkoutMetaContext;
